module.exports = __webpack_public_path__ + "img/img_C3.12.19.06c9afd2.png";